export const genericNL = {
  Annuleren: "Annuleren",
  BedanktBericht: "Bedankt voor uw bericht. Uw bericht heeft referentienummer: {{klantContactId}}",
  Burgerservicenummer: "Burgerservicenummer",
  DateInputPlaceHolder: "dd-mm-jjjj",
  Datum: "Datum",
  DeVeldenMetEenzijnVerplicht: "De velden met een * zijn verplicht.",
  DownloadFile: "Download",
  DropdownSelecteerEenOptie: "Kies een optie",
  ErrorTextOnGetDataOnSubmitError:
    "Er is een fout opgetreden tijdens ophalen informatie. Probeer het later opnieuw.",
  ErrorFormSubmit: "Het inzenden van het formulier is mislukt: {{errorMessage}}",
  Geboortedatum: "Geboortedatum",
  Geslacht: "Geslacht",
  Ja: "Ja",
  MaxLengthMessage: `U heeft het maximaal aantal karakters ingevoerd.`,
  Man: "Man",
  MeldingNoteerNummerNaVerzending: "Noteer bovenstaand nummer. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  NaarOnzeHomepage: "Naar onze homepage",
  Nee: "Nee",
  LetOp: "Let op",
  Onbekend: "Onbekend",
  OnjuisteInvoer: "Dit is een onjuiste {{property}}.",
  tekens: "tekens",
  TerugNaarHetFormulier: "Terug naar het formulier",
  Verwijderfile: "Verwijderen",
  Verzenden: "Verzenden",
  Volgende: "Volgende",
  Vorige: "Vorige",
  Vrouw: "Vrouw",
  Wijzigen: "Wijzigen",
  Wissen: "Wissen"
};

export const genericEN = {
  Annuleren: "Cancel",
  BedanktBericht: "Thank you for your message. Your message has reference number: {{klantContactId}}",
  Burgerservicenummer: "Social security number",
  DateInputPlaceHolder: "dd-mm-yyyy",
  Datum: "Date",
  DeVeldenMetEenzijnVerplicht: "The fields marked with an * are required.",
  DownloadFile: "Download",
  DropdownSelecteerEenOptie: "Choose an option",
  ErrorTextOnGetDataOnSubmitError: "An error occurred when retrieving data. Please try again later.",
  ErrorFormSubmit: "Submitting of the form failed: {{errorMessage}}",
  Geboortedatum: "Date of birth",
  Geslacht: "Gender",
  Ja: "Yes",
  MaxLengthMessage: `You have entered the maximum number of characters.`,
  Man: "Man",
  MeldingNoteerNummerNaVerzending:
    "Make a note of the number above. Please mention this number when you contact us with a question. This way we can help you better.",
  MeldingNoteerNummerVoorVerzending:
    "Note the number that appears after sending. Do you have any questions? Then pass on this number. This way we can help you better.",
  NaarOnzeHomepage: "Go to our homepage",
  Nee: "No",
  LetOp: "Attention",
  Onbekend: "Unknown",
  OnjuisteInvoer: "This is an incorrect {{property}}.",
  tekens: "characters",
  TerugNaarHetFormulier: "Back to the form",
  Verwijderfile: "Remove",
  Verzenden: "Send",
  Volgende: "Next",
  Vorige: "Previous",
  Vrouw: "Woman",
  Wijzigen: "Edit",
  Wissen: "Delete"
};
